import { Component, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from './services/loader.service';
import { AppUtilsService } from './services/app-utils.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewChecked {
  loadER: any;
  loaderImage: string = "assets/img/cdlogo.gif";
  showHeader: boolean = true;
  constructor(private loader: LoaderService, private cdRef: ChangeDetectorRef, private appUtil: AppUtilsService, private titleService: Title,
    private router: Router, private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    console.log("First calling appcomponent")
    localStorage.removeItem("menuData");
    localStorage.setItem("enableFoodType", "true");


    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      })
    ).subscribe(route => {
      route.data.subscribe(data => {
        this.showHeader = data.showHeader !== false;
      });
    });

    this.appUtil.browserTabName.subscribe((tabName: string) => {
      tabName = localStorage.getItem("tabName");
      this.titleService.setTitle(tabName);
      this.setFavicon(localStorage.getItem("applogo") ? localStorage.getItem("applogo") : "assets/img/favicon-32x32.png");
      // if (tabName === 'ChefDesk') {
      //   this.setFavicon("favicon-32x32.png");
      // } else {
      //   this.setFavicon(this.appUtil.logo);
      // }
    });

    this.appUtil.loaderImage.subscribe((img: string) => {
      img = localStorage.getItem("loaderImage");
      console.log("Loader Image:::", img);
      this.loaderImage = img ? img : "assets/img/cdlogo.gif";
      console.log("Loader Image:::", this.loaderImage);
    });

    this.loader.status.subscribe((val: any) => {
      this.loadER = val;
      // console.log('got response =============================>>>>>>>>>>>>>>>>>>>>>>>>>' + this.loadER);

    }, (error: any) => {
      console.log(error);
    });
  }

  handleError() {
    console.log("LoaderImage error:::")
    localStorage.setItem("loaderImage", "assets/img/cdlogo.gif");
    this.loaderImage = "assets/img/cdlogo.gif";
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  private setFavicon(faviconPath: string): void {
    console.log("faviconPath:::" + faviconPath)
    const link: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = faviconPath;
    document.head.appendChild(link);
  }
}
